/**
 * @generated SignedSource<<614e2168511e5ec8a085b9096e604fbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BaseDataEquity_content$data = {
  readonly currency: string | null | undefined;
  readonly date: string | null | undefined;
  readonly datetext: string | null | undefined;
  readonly text: string | null | undefined;
  readonly value: string | null | undefined;
  readonly " $fragmentType": "BaseDataEquity_content";
};
export type BaseDataEquity_content$key = {
  readonly " $data"?: BaseDataEquity_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"BaseDataEquity_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BaseDataEquity_content",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "datetext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    }
  ],
  "type": "BaseDataEquity",
  "abstractKey": null
};

(node as any).hash = "1d1fd0e4e5579f349fef2383af0e07aa";

export default node;
